import {createReducer} from '@reduxjs/toolkit'
import {changeCalendarCategory} from '../actions/calendar-layout'
import {setVeloCategoryFilter} from '../actions/velo-overrides'

export interface DynamicVeloOverridesState {
  categoryId: string
}

const initialState: DynamicVeloOverridesState = {
  categoryId: null,
}

export const dynamicVeloOverrides = createReducer(initialState, builder => {
  builder
    .addCase(setVeloCategoryFilter, (state, {payload}) => {
      state.categoryId = payload
    })
    .addCase(changeCalendarCategory.pending, (state, {meta}) => {
      state.categoryId = meta.arg.veloCategoryId
    })
    .addCase(changeCalendarCategory.rejected, (state, {meta}) => {
      state.categoryId = meta.arg.oldVeloCategoryId
    })
})
